import * as React from 'react';
import { connect } from 'react-redux';

import LightweightProfileCard from './LightweightProfileCard';
import LightweightProfileForm from './LightweightProfileForm';
import { ModalFrame } from 'components/modal';

import { __t, applyTranslations } from 'utils/language';
import { logError } from 'utils/log';

import { createLightweightProfile, resetLightweightProfile } from '../reducers/lightweightProfile';

import type { InfluencerProfile, InfluencerProfileFormLightweight } from 'types';

applyTranslations(require('./lightweight-profile-modal.json'));

type OwnProps = {
  organizationId?: number,
  onProfileCreated: () => void,
  onBeforeCloseModal: () => void,
  onAddAnotherPost?: () => void,
  instagramChannel?: string
};

type DispatchProps = {
  dispatchCreateLightweightProfile: (b: InfluencerProfileFormLightweight, a?: number | null) => Promise<InfluencerProfile>,
  dispatchResetLightweightProfile: () => void
};

type Props = OwnProps & DispatchProps;
type Mode = 'create' | 'view';

type State = {
  mode: Mode
};

const MODE_CREATE = 'create';
const MODE_VIEW = 'view';

class LightweightProfileModal extends React.Component<Props, State> {
  state: State = {
    mode: MODE_CREATE
  };

  componentWillUnmount() {
    const { dispatchResetLightweightProfile } = this.props;
    dispatchResetLightweightProfile();
  }

  handleProfileCreation = (profileDetails: InfluencerProfileFormLightweight): Promise<InfluencerProfile | undefined | null> => {
    const { organizationId, dispatchCreateLightweightProfile, onProfileCreated } = this.props;

    return dispatchCreateLightweightProfile(profileDetails, organizationId)
      .then(influencerProfile => {
        if (influencerProfile.isProfileNew) {
          this.handleModeChange(MODE_VIEW);
          onProfileCreated();
        }

        return influencerProfile;
      })
      .catch(error => {
        logError(error);
        return null;
      });
  };

  handleModeChange = (mode: Mode) => {
    this.setState({ mode });
  };

  render(): React.ReactNode {
    const { onBeforeCloseModal, instagramChannel, onAddAnotherPost } = this.props;
    const { mode } = this.state;

    const isCreateMode = mode === MODE_CREATE;

    return (
      <ModalFrame
        title={isCreateMode ? __t('lightweight_profile_form.form.title') : __t('lightweight_profile_card.title')}
      >
        {
          isCreateMode ?
            <LightweightProfileForm
              onSubmit={this.handleProfileCreation}
              onCancel={onBeforeCloseModal}
              instagramChannel={instagramChannel}
            /> :
            <LightweightProfileCard
              onNextButtonClick={() => this.handleModeChange(MODE_CREATE)}
              onAddAnotherPost={onAddAnotherPost}
            />
        }
      </ModalFrame>
    );
  }
}

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchCreateLightweightProfile: (details, organizationId) => dispatch(createLightweightProfile(details, organizationId)),
  dispatchResetLightweightProfile: () => dispatch(resetLightweightProfile())
});

export default connect(null, mapDispatchToProps)(LightweightProfileModal);
